import { analyticsRepository } from "@/repositories/analytics";
import { useStore } from "@/stores/useStore";
import { useCallback } from "react";

const RoPanelEventNames = {
  panelOpened: "ro_panel_opened",
  panelActionUsed: "ro_panel_action_used",
} as const;

type RoPanelEventNames =
  (typeof RoPanelEventNames)[keyof typeof RoPanelEventNames];

export const useRoPanelAnalytics = () => {
  const shopId = useStore((s) => s.shopId);

  const analyticsWrapper = useCallback(
    (eventName: RoPanelEventNames, params?: Record<string, unknown>) => {
      if (!shopId) {
        console.error(
          "Shop ID is missing, cannot log analytics event:",
          eventName
        );
        return;
      }
      analyticsRepository.logAnalyticsEvent(eventName, { ...params, shopId });
    },
    [shopId]
  );

  const logPanelOpened = useCallback(() => {
    analyticsWrapper(RoPanelEventNames.panelOpened);
  }, [analyticsWrapper]);

  const logPanelActionUsed = useCallback(
    (action: string) => {
      analyticsWrapper(RoPanelEventNames.panelActionUsed, { action });
    },
    [analyticsWrapper]
  );

  return { logPanelOpened, logPanelActionUsed };
};
